export default __webpack_public_path__ + "a6824a551e1470fda20da870a8e89b8d.svg";